export default __webpack_public_path__ + "static/media/erp.a8e01a13.png";